import { Sparkles, X } from "lucide-react";
import { useState } from "react";

export const FloatingOwnershipBot = ({ onCtaClick }) => {
  const [isClosed, setIsClosed] = useState(false);

  if (isClosed) return null;

  return (
    <div className="hidden md:block fixed bottom-3 left-3 z-[70] sm:bottom-6 sm:left-6" data-testid="floating-ownership-bot">
      <style>{`
        @keyframes ownership-poster-sway {
          0%, 100% { transform: rotate(-1deg) translateY(0px); }
          50% { transform: rotate(1deg) translateY(-2px); }
        }
      `}</style>
      <div className="relative w-[142px] sm:w-[168px]" data-testid="floating-ownership-bot-layout">
        <div className="origin-bottom-left" data-testid="floating-ownership-bot-sway-wrapper" style={{ animation: "ownership-poster-sway 4.8s ease-in-out infinite" }}>
          <div
            className="group relative rounded-[22px] bg-[linear-gradient(165deg,#fff7df_0%,#f4c254_34%,#d97a1d_100%)] p-[1px] shadow-[0_16px_28px_rgba(0,25,53,0.12),0_26px_62px_rgba(0,25,53,0.16)] transition duration-300 hover:-translate-y-1 hover:shadow-[0_20px_34px_rgba(0,25,53,0.14),0_30px_72px_rgba(0,25,53,0.2)] [transform:perspective(900px)_rotateX(10deg)]"
            data-testid="floating-ownership-bot-card-shell"
          >
            <div
              className="relative overflow-hidden rounded-[21px] bg-[linear-gradient(180deg,rgba(255,250,240,0.98)_0%,rgba(247,201,95,0.9)_56%,rgba(206,108,24,0.96)_100%)] px-2 pb-2 pt-1.5 text-[#001935] sm:px-2.5 sm:pb-2.5"
              data-testid="floating-ownership-bot-card"
            >
              <div className="pointer-events-none absolute inset-x-3 top-2 h-6 rounded-full bg-white/28 blur-md" />
              <div className="pointer-events-none absolute inset-0 rounded-[21px] shadow-[inset_0_1px_0_rgba(255,255,255,0.34),inset_0_-18px_34px_rgba(0,25,53,0.08)]" />
              <button
                aria-label="Close floating ownership bot"
                className="absolute right-1.5 top-1.5 inline-flex h-5 w-5 items-center justify-center rounded-full border border-[#001935]/12 bg-white/75 text-[#001935] transition hover:bg-white"
                data-testid="floating-ownership-bot-close-button"
                onClick={() => setIsClosed(true)}
                type="button"
              >
                <X className="h-3 w-3" />
              </button>

              <span className="relative inline-flex items-center gap-1 rounded-full bg-[rgba(0,25,53,0.9)] px-1.5 py-1 text-[7px] font-bold uppercase tracking-[0.14em] text-[#F7D47A]" data-testid="floating-ownership-bot-badge">
                <Sparkles className="h-2.5 w-2.5" /> Own Leads
              </span>

              <p className="relative mt-1.5 max-w-[100px] font-[Cormorant_Garamond,serif] text-[0.92rem] font-bold leading-[0.96] text-white drop-shadow-[0_1px_6px_rgba(0,25,53,0.18)] sm:max-w-[118px] sm:text-[1.03rem]" data-testid="floating-ownership-bot-message">
                Stop buying leads, own them
              </p>

              <button
                className="relative mt-2 inline-flex w-full items-center justify-center rounded-full border border-white/35 bg-[rgba(0,25,53,0.92)] px-2 py-1.5 text-[9px] font-bold tracking-[0.04em] text-[#F7D47A] transition hover:-translate-y-0.5 hover:bg-[#001935]"
                data-testid="floating-ownership-bot-cta"
                onClick={onCtaClick}
                type="button"
              >
                Subscribe Now !
              </button>

              <p className="relative mt-1 text-center text-[7px] font-semibold uppercase tracking-[0.14em] text-white/85" data-testid="floating-ownership-bot-footnote">
                SG Prop Portal
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};